import {Body, Desc, Images, Logo, Next, PageIcon, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {ContainerImage} from "../../components/Container";
import {ChatButton} from "./Chat/button";
import Chat from "./Chat";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {ChatHeader} from "./Chat/style";
import {message} from "antd";
import produce, {current} from "immer";
import TencentCloudChat, {ChatSDK} from "@tencentcloud/chat";
import {postJoinChat, sleep} from "./Chat/connector";
import Call from "./Call";
import {addCallUser, delCallUser, putUpdateCallInfoProfile} from "../../services/app";
import {sentCallStateMessage} from "./Call/tencent";
import {cleanAnonymousChatThread} from "../AnonymoysChat/popup";

export default function Success(props: any) {
    const {
        campaignPath,
        campaignId,
        customerId,
        productServiceType,
        productServiceId,
        productServiceTemplateId,
    } = useParams();
    const navigate = useNavigate();
    const {T} = useApp();
    const {themeColors, clientCode, campaign} = useApp();
    const queries = new URLSearchParams(window.location.search);
    const bookingId = props.bookingId || queries.get("bookingId") || "";
    const [thread, setThread] = useState<{
        chatSDK?: ChatSDK;
        callEngine?: any;
        tencentUserId?: string;
        tencentGroupId?: string;
        endChatAt?: string;
        name?: string;
        threadId?: string;
        hidden?: boolean;
        calling?: boolean;
        callInfo?: any;
    }>(null);
    const [accessChat, setAccessChat] = useState(false);
    const [ready, setReady] = useState(false);
    const callRef = useRef<any>(null);
    const [callInvited, setCallInvited] = useState<any>(false);
    const [calling, setCalling] = useState(false);
    const [view, setView] = useState<'history' | 'chat' | 'call'>('chat');
    const timerAutoEndCallRef = useRef<any>({});
    const cleanUpSession = useCallback((haveClean?: boolean) => {
        if (haveClean) {
            localStorage.clear();
        }
        try {
            if (!!thread?.chatSDK) {
                thread?.chatSDK?.destroy?.();
            }
            if (thread?.callEngine) {
                thread?.callEngine?.destroy?.();
            }
        } catch (e) {
        }
    }, [thread]);

    useEffect(() => {
        // @ts-ignore
        window.chatSDK = thread?.chatSDK;
        // @ts-ignore
        window.callEngine = thread?.callEngine;
    }, [thread]);

    useEffect(() => {
        cleanAnonymousChatThread();
        return () => {
            // clean current chat thread
            try {
                if (!!thread?.chatSDK) {
                    thread?.chatSDK?.destroy?.();
                }
                if (thread?.callEngine) {
                    thread?.callEngine?.destroy?.();
                }
            } catch (e) {
            }
        }
    }, []);

    useEffect(() => {
        const localBookingId = window.localStorage.getItem("bookingId")
        if (localBookingId === bookingId || window.location.href.includes('localhost')) {
            setAccessChat(!!campaign?.isOnLiveChat);
        }
    }, [campaign?.isOnLiveChat]);

    useEffect(() => {
        if (!!thread?.chatSDK) {
            updateCallInfoProfile().then();
            (async () => {
                if (!thread?.chatSDK.isReady()) {
                    thread.chatSDK.on(TencentCloudChat.EVENT.SDK_READY, (async () => {
                        sleep(500).then(async () => {
                            await postJoinChat(bookingId, thread?.threadId);
                            setReady(true);
                        });
                    }))
                } else {
                    await postJoinChat(bookingId, thread?.threadId);
                    setReady(true);
                }
            })();
        }
    }, [!!thread?.chatSDK]);

    const updateCallInfoProfile = useCallback(async () => {
        if (thread?.callEngine) {
            thread?.callEngine.setSelfInfo({
                nickName: T("Customer"),
                avatar: 'https://null.png',
            }).catch(reason => null);
            const userInfo = {};
            userInfo[thread.tencentUserId] = {
                userID: thread.tencentUserId,
                nick: T("Customer") || "",
                nickName: T("Customer") || "",
                avatar: 'https://null.png',
            };
            putUpdateCallInfoProfile(thread.threadId, userInfo).catch(reason => null);
        }
    }, [thread])

    const onAutoEndCall = (callInfo) => {
        if (timerAutoEndCallRef?.current?.timer) {
            clearTimeout(timerAutoEndCallRef.current.timer);
        }
        timerAutoEndCallRef.current = {
            timer: setTimeout(() => {
                callRef.current.endCall();
                message.info(T("Call has been ended automatically after 1 hour"));
            }, 1000 * 60 * 60 * 1), // Auto end call after 1 hours
            roomID: callInfo?.roomID || thread?.tencentGroupId,
        }
    }

    const onNext = useCallback(() => {
        cleanUpSession(true);
        // Navigate to home page
        navigate(`/${clientCode}/${campaignPath}/`, {replace: true});
    }, [cleanUpSession, navigate, clientCode, campaignPath]);

    const renderChat = () => (
        <>
            {
                !!thread && ready ? (
                    <div style={{
                        position: 'fixed',
                        width: "100%",
                        height: '100%',
                        zIndex: 2,
                        display: !!thread?.hidden ? "none" : "block"
                    }}>
                        <Chat
                            isEndedChat={!!thread?.endChatAt}
                            bookingId={bookingId}
                            tencentGroupId={thread.tencentGroupId}
                            mode={'customer'}
                            tencentUserId={thread.tencentUserId}
                            chatSDK={thread.chatSDK}
                            threadId={thread.threadId}
                            name={thread?.name}
                            callInvited={callInvited}
                            onAcceptInviteCall={() => {
                                callRef.current.onAcceptInviteCall({
                                    ...callInvited,
                                    groupID: thread.tencentGroupId,
                                });
                                setCallInvited(false);
                            }}
                            header={(<ChatHeader
                                view={view}
                                callType={thread?.callInfo?.callType}
                                setView={setView}
                                calling={!!calling}
                                name={(thread?.name || "")}
                                onMinus={() => {
                                    setThread(produce((draft: any) => {
                                        draft.hidden = true
                                    }))
                                }}/>)}
                            onMessage={(eventName, beMessage) => {
                                if (eventName === 'END-CHAT' && thread?.tencentGroupId === beMessage?.tencentGroupId) {
                                    // Destroy chat sdk
                                    try {
                                        if (!!thread?.chatSDK) {
                                            thread?.chatSDK?.destroy?.();
                                        }
                                        if (thread?.callEngine) {
                                            thread?.callEngine?.destroy?.();
                                        }
                                    } catch (e) {
                                    }
                                    setThread(null);
                                    message.destroy();
                                }
                                if (eventName === 'MESSAGE') {
                                    // setThread(produce((draft: any) => {
                                    //     const currentThead = current(draft);
                                    //     if (!!currentThead?.hidden && currentThead?.tencentGroupId === beMessage?.tencentGroupId) {
                                    //         draft.hidden = false;
                                    //     }
                                    // }))
                                }
                            }}
                        />
                        <Call
                            view={view}
                            user={{
                                fullName: T("Customer"),
                                avatar: "",
                                userName: thread.tencentUserId
                            }}
                            ref={callRef}
                            callEngine={thread?.callEngine}
                            onInvite={(event) => {
                                console.log("onInvite", event);
                                // Check if the call in group
                                if (event?.groupID === thread.tencentGroupId || event?.groupID === thread.threadId) {
                                    setCallInvited(event);
                                } else {
                                    callRef?.current?.endCall();
                                }
                            }}
                            onUserLeave={(userID) => {
                                console.log("onUserLeave", userID);
                                setThread(produce((draft: any) => {
                                    const currentThead = current(draft);
                                    delCallUser(currentThead?.threadId, userID).finally(() => {
                                    });
                                }))
                            }}
                            onStartCall={(callInfo) => {
                                onAutoEndCall(callInfo);
                                setView('call');
                                addCallUser(thread?.threadId, thread?.tencentUserId).finally(() => {
                                    sentCallStateMessage(thread?.chatSDK, thread?.tencentGroupId, {
                                        tencentUserId: thread?.tencentUserId,
                                        bookingId: bookingId,
                                        tencentGroupId: thread?.tencentGroupId,
                                        threadId: thread?.threadId,
                                        name: thread?.name || "",
                                        isCalling: false,
                                    }, "CALL-JOIN-STATE").then()
                                });
                            }}
                            onEndCall={() => {
                                setCallInvited(false);
                                setThread(produce((draft: any) => {
                                    const currentThead = current(draft);
                                    delCallUser(currentThead?.threadId, currentThead?.tencentUserId).finally(() => {
                                        sentCallStateMessage(currentThead?.chatSDK, currentThead?.tencentGroupId, {
                                            tencentUserId: currentThead?.tencentUserId,
                                            bookingId: bookingId,
                                            tencentGroupId: currentThead?.tencentGroupId,
                                            threadId: currentThead?.threadId,
                                            name: currentThead?.name || "",
                                            isCalling: false,
                                        }, "CALL-LEAVE-STATE").then()
                                    });
                                }))
                                if (timerAutoEndCallRef?.current?.timer) {
                                    clearTimeout(timerAutoEndCallRef.current.timer);
                                }
                                timerAutoEndCallRef.current = {
                                    timer: null,
                                    roomID: null,
                                };
                            }}
                            onChange={(calling, callInfo) => {
                                console.log('onChange', calling, callInfo);
                                if (!calling && !!callInvited) {
                                    setCallInvited(false);
                                }
                                setThread(produce((draft: any) => {
                                    draft.calling = calling;
                                    draft.callInfo = callInfo;
                                }))
                                setCalling(calling);
                            }}
                            mode={'customer'}
                        />
                    </div>
                ) : null
            }
            {
                (
                    accessChat ? (
                        <ChatButton
                            thread={thread}
                            bookingId={bookingId}
                            onSubmit={(event) => {
                                console.log('eevent', event);
                                setThread({...event, hidden: false});
                            }}
                        />
                    ) : null
                )
            }
        </>
    )

    return (
        <ContainerImage style={{minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Logo style={{
                height: (!themeColors?.main ? "auto" : 0),
                opacity: (!themeColors?.main ? 1 : 0)
            }}>
                <LogoIcon style={{height: 81, marginTop: 30, width: 'auto'}}/>
            </Logo>
            <Body>
                <Images>
                    <PageIcon mainColor={themeColors?.main}/>
                </Images>
                <Title>
                    <h3>{T("We've got your booking!")}</h3>
                    <p>{T('A confirmation email will be sent to you shortly.')}<br/>{T('Thank you and have a nice day!')}
                    </p>
                </Title>
                <Desc></Desc>

                <Next onClick={onNext}>{T("Done")}</Next>


                {renderChat()}
            </Body>
        </ContainerImage>
    );
}
